var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverarrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3682 4.30164C18.5822 1.75164 15.9202 -0.911364 13.3692 0.302636L1.71023 5.85464C-0.679773 6.99264 -0.531773 10.4436 1.94723 11.3726L4.68623 12.3996C4.81983 12.4498 4.94116 12.5279 5.04206 12.6288C5.14296 12.7297 5.2211 12.851 5.27123 12.9846L6.29823 15.7246C7.22823 18.2026 10.6782 18.3506 11.8162 15.9606L17.3682 4.30164Z",
    fill: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverarrowicon);
export default __webpack_public_path__ + "static/media/Hoverarrowicon.49a8815acae94631330755f92b2156a7.svg";
export { ForwardRef as ReactComponent };